import React from 'react';
import loader from '../../../svg/dot-preloader-dark.svg';
import styled from 'styled-components';

const FullPageSpinnerWrapper = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  min-height: 400px;
  background: rgba(255, 255, 255, 0.1);
  transition: 0.3s;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'block')};
  div {
    position: absolute;
    width: 30px;
    height: 30px;
    left: 50%;
    top: 50%;
    margin-left: -10px;
    margin-top: -10px;
  }
`;

const FullPagePreloader: React.FC = () => {
  return (
    <FullPageSpinnerWrapper isVisible={true}>
      <div>
        <img src={loader} alt="loading..." />
      </div>
    </FullPageSpinnerWrapper>
  );
};

export default FullPagePreloader;
